export default {
// --- Specific for single activity embed  ---
  // Relationships
  global_slide: {
    jsonApi: 'hasOne',
    type: 'global_slide'
  },

  resources: {
    jsonApi: 'hasMany',
    type: 'resource_cards'
  },

  // Attributes
  overlay: null,
  configuration: null,
  // ------------------------------------------

  // Images
  background_image: null,
  gradient_start: null,
  gradient_end: null,

  // Attributes
  label: null,
  headline: null,
  subheadline: null
}
